namespace GeniuzPOS.ReportMasterData {
    export interface Report_1503Form {
    }

    export class Report_1503Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1503';
    }
}
